/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronMiniLeft: {
  name: 'chevron-mini-left';
  data: string;
} = {
  name: 'chevron-mini-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.707 8.293a1 1 0 0 1 0 1.414L11.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Z" fill="currentColor"/></svg>`,
};
